<template>
    <div class="mh-100 h-100">
        <div class="main-image-container">
            <div class="secondary-nav justify-content-center">
                <div class="align-items-center d-flex gap-10">
                    <svg
                        :class="{
                            'cursor-pointer': zoom > 0.5,
                            disabled: zoom <= 0.5,
                        }"
                        @click="handleDecreaseZoom"
                        :opacity="zoom === 0.5 ? 0.5 : 1"
                        width="30"
                        height="30"
                        viewBox="0 0 30 30"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <rect x="0.5" y="0.5" width="29" height="29" rx="4.5" fill="#383838" />
                        <rect x="0.5" y="0.5" width="29" height="29" rx="4.5" stroke="#595959" />
                        <path
                            d="M24.9001 13.65V16.35C24.9001 16.725 24.7688 17.0438 24.5063 17.3063C24.2438 17.5688 23.9251 17.7 23.5501 17.7H6.4501C6.0751 17.7 5.75635 17.5688 5.49385 17.3063C5.23135 17.0438 5.1001 16.725 5.1001 16.35V13.65C5.1001 13.275 5.23135 12.9563 5.49385 12.6938C5.75635 12.4313 6.0751 12.3 6.4501 12.3H23.5501C23.9251 12.3 24.2438 12.4313 24.5063 12.6938C24.7688 12.9563 24.9001 13.275 24.9001 13.65Z"
                            fill="#E8EAED"
                        />
                    </svg>

                    {{ this.zoomLevel }}
                    <svg
                        :class="{
                            'cursor-pointer': zoom < 4,
                            disabled: zoom >= 4,
                        }"
                        @click="handleIncreaseZoom"
                        :opacity="zoom === 4 ? 0.5 : 1"
                        width="30"
                        height="30"
                        viewBox="0 0 30 30"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <rect x="0.5" y="0.5" width="29" height="29" rx="4.5" fill="#383838" />
                        <rect x="0.5" y="0.5" width="29" height="29" rx="4.5" stroke="#595959" />
                        <path
                            d="M24 13.7727V16.2273C24 16.5682 23.8807 16.858 23.642 17.0966C23.4034 17.3352 23.1136 17.4545 22.7727 17.4545H17.4545V22.7727C17.4545 23.1136 17.3352 23.4034 17.0966 23.642C16.858 23.8807 16.5682 24 16.2273 24H13.7727C13.4318 24 13.142 23.8807 12.9034 23.642C12.6648 23.4034 12.5455 23.1136 12.5455 22.7727V17.4545H7.22727C6.88636 17.4545 6.59659 17.3352 6.35795 17.0966C6.11932 16.858 6 16.5682 6 16.2273V13.7727C6 13.4318 6.11932 13.142 6.35795 12.9034C6.59659 12.6648 6.88636 12.5455 7.22727 12.5455H12.5455V7.22727C12.5455 6.88636 12.6648 6.59659 12.9034 6.35795C13.142 6.11932 13.4318 6 13.7727 6H16.2273C16.5682 6 16.858 6.11932 17.0966 6.35795C17.3352 6.59659 17.4545 6.88636 17.4545 7.22727V12.5455H22.7727C23.1136 12.5455 23.4034 12.6648 23.642 12.9034C23.8807 13.142 24 13.4318 24 13.7727Z"
                            fill="#E8EAED"
                        />
                    </svg>
                </div>
            </div>
            <div v-if="currentJob.state === 'processing'" class="mh-100 h-100">
                <div class="gallery-1 overflow-hidden">
                    <div class="gallery-row d-flex justify-content-center loading">
                        <div class="image align-items-center justify-content-center">
                            <img :src="loadingImage" />
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="currentJob.state === 'completed'" class="mh-100 h-100">
                <div class="gallery-1 overflow-hidden">
                    <div class="gallery-row d-flex justify-content-center">
                        <canvas
                            @mousedown="onPointerDown"
                            @touchstart="handleTouch($event, onPointerDown)"
                            @mouseup="onPointerUp"
                            @touchend="handleTouch($event, onPointerUp)"
                            @mousemove="onPointerMove"
                            @touchmove="handleTouch($event, onPointerMove)"
                            @wheel="handleZoom($event)"
                            @dblclick="handleZoomOnDbClick"
                            id="viewport"
                            ref="canvas"
                        ></canvas>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import store from './../../../mixins/store.mixin';
import currentJob from './../../../mixins/current_job.mixin';
import AspectRatioManager from '../../../manager/AspectRatioManager';

export default {
    name: 'OneImageView',
    props: {},
    components: {},
    mixins: [store, currentJob],
    data() {
        return {
            zoom: 1,
            zoomSpeed: 0.05,
            clicking: false,
            previousX: 0,
            previousY: 0,
            cameraOffset: { x: window.innerWidth / 2, y: window.innerHeight / 2 },
            zoom: 1,
            MAX_ZOOM: 5,
            MIN_ZOOM: 0.1,
            SCROLL_SENSITIVITY: 0.0005,
            isDragging: false,
            dragStart: { x: 0, y: 0 },
        };
    },
    mounted: function () {
        if(this.currentJob.base64_output_images.length > 0){
            this.loadImage(this.currentJob.base64_output_images[0])
        }
        this.$watch(
            () => this.currentJob.base64_output_images,
            (newValue, oldValue) => {
                if (newValue.length > 0) {
                    this.loadImage(newValue[0])
                }
            }
        );
    },
    created: function () {},
    methods: {
        loadImage(src){
            const image = new Image();
            image.src = src
            image.onload = () => {
                this.cameraOffset.x = window.innerWidth / 2;
                this.cameraOffset.y = window.innerHeight / 2;
                this.zoom = 1;
                this.draw(image);
            };
        },
        draw(image) {
            const canvas = this.$refs.canvas;
            const ctx = canvas?.getContext('2d');
            canvas.width = window.innerWidth;
            canvas.height = window.innerHeight;

            ctx.clearRect(0, 0, window.innerWidth, window.innerHeight);

            // Translate to the canvas centre before zooming
            ctx.translate(window.innerWidth / 2, window.innerHeight / 2);
            ctx.scale(this.zoom, this.zoom);
            ctx.translate(-window.innerWidth / 2 + this.cameraOffset.x, -window.innerHeight / 2 + this.cameraOffset.y);

            ctx.drawImage(image, -image.width / 2, -image.height / 2);

            requestAnimationFrame(() => this.draw(image));
        },
        onPointerDown(e) {
            this.isDragging = true;
            this.dragStart.x = this.getEventLocation(e).x / this.zoom - this.cameraOffset.x;
            this.dragStart.y = this.getEventLocation(e).y / this.zoom - this.cameraOffset.y;
        },
        onPointerUp() {
            this.isDragging = false;
        },
        onPointerMove(e) {
            if (this.isDragging) {
                this.cameraOffset.x = this.getEventLocation(e).x / this.zoom - this.dragStart.x;
                this.cameraOffset.y = this.getEventLocation(e).y / this.zoom - this.dragStart.y;
            }
        },
        handleTouch(e, singleTouchHandler) {
            if (e.touches.length === 1) {
                singleTouchHandler(e);
            } else if (e.type === 'touchmove' && e.touches.length === 2) {
                this.isDragging = false;
                handlePinch(e);
            }
        },
        handlePinch(e) {
            e.preventDefault();
            let initialPinchDistance = null;
            let touch1 = { x: e.touches[0].clientX, y: e.touches[0].clientY };
            let touch2 = { x: e.touches[1].clientX, y: e.touches[1].clientY };

            let currentDistance = (touch1.x - touch2.x) ** 2 + (touch1.y - touch2.y) ** 2;

            if (initialPinchDistance === null) {
                initialPinchDistance = currentDistance;
            } else {
                adjustZoom(null, currentDistance / initialPinchDistance);
            }
        },
        adjustZoom(zoomAmount, zoomFactor) {
            let lastZoom = this.zoom;
            if (!this.isDragging) {
                if (zoomAmount) {
                    this.zoom += zoomAmount;
                } else if (zoomFactor) {
                    this.zoom = zoomFactor * lastZoom;
                }

                this.zoom = Math.min(this.zoom, this.MAX_ZOOM);
                this.zoom = Math.max(this.zoom, this.MIN_ZOOM);
            }
        },
        getEventLocation(e) {
            if (e.touches && e.touches.length === 1) {
                return { x: e.touches[0].clientX, y: e.touches[0].clientY };
            } else if (e.clientX && e.clientY) {
                return { x: e.clientX, y: e.clientY };
            }
        },
        handleZoom(e) {
            //ZOOM IN
            if (e.deltaY < 0) {
                if (this.zoom >= 0.5) {
                    this.zoom += this.zoomSpeed;
                    if (this.zoom > 4) this.zoom = 4;
                }
            } else {
                //ZOOM OUT
                let scale = this.zoom - this.zoomSpeed;
                if (scale >= 0.5) {
                    this.zoom -= this.zoomSpeed;
                } else {
                    //Stop Zoom out at half Original Image size
                    this.zoom = 0.5;
                }
            }
        },
        handleZoomOnDbClick() {
            if (this.zoom === 1) {
                this.zoom = 2;
            } else {
                this.zoom = 1;
                this.cameraOffset.x = window.innerWidth / 2;
                this.cameraOffset.y = window.innerHeight / 2;
            }
        },
        handleIncreaseZoom() {
            if (this.zoom === 4) return;
            switch (true) {
                case this.zoom < 0.75:
                    this.zoom = 0.75;
                    break;
                case this.zoom < 1:
                    this.zoom = 1;
                    break;
                case this.zoom < 1.5:
                    this.zoom = 1.5;
                    break;
                case this.zoom < 1.75:
                    this.zoom = 1.75;
                    break;
                case this.zoom < 2:
                    this.zoom = 2;
                    break;
                case this.zoom < 2.25:
                    this.zoom = 2.25;
                    break;
                case this.zoom < 2.5:
                    this.zoom = 2.5;
                    break;
                case this.zoom < 2.75:
                    this.zoom = 2.75;
                    break;
                case this.zoom < 3:
                    this.zoom = 3;
                    break;
                case this.zoom < 3.25:
                    this.zoom = 3.25;
                    break;
                case this.zoom < 3.5:
                    this.zoom = 3.5;
                    break;
                case this.zoom < 3.75:
                    this.zoom = 3.75;
                    break;
                case this.zoom <= 4:
                    this.zoom = 4;
                    break;
                case this.zoom > 4:
                    this.zoom = 4;
                    break;
                default:
                    return this.zoom;
            }
        },
        handleDecreaseZoom() {
            switch (true) {
                case this.zoom <= 0.75:
                    this.zoom = 0.5;
                    break;
                case this.zoom <= 1:
                    this.zoom = 0.75;
                    break;
                case this.zoom <= 1.25:
                    this.zoom = 1;
                    break;
                case this.zoom <= 1.5:
                    this.zoom = 1.25;
                    break;
                case this.zoom <= 1.75:
                    this.zoom = 1.5;
                    break;
                case this.zoom <= 2:
                    this.zoom = 1.75;
                    break;
                case this.zoom <= 2.25:
                    this.zoom = 2;
                    break;
                case this.zoom <= 2.5:
                    this.zoom = 2.25;
                    break;
                case this.zoom <= 2.75:
                    this.zoom = 2.5;
                    break;
                case this.zoom <= 3:
                    this.zoom = 2.75;
                    break;
                case this.zoom <= 3.25:
                    this.zoom = 3;
                    break;
                case this.zoom <= 3.5:
                    this.zoom = 3.25;
                    break;
                case this.zoom <= 3.75:
                    this.zoom = 3.5;
                    break;
                case this.zoom <= 4:
                    this.zoom = 3.75;
                    break;
                default:
                    return this.zoom;
            }
        },
    },
    computed: {
        loadingImage() {
            return AspectRatioManager.getBySize(this.currentJob.settings.conversion.options.aspect_ratio).loading;
        },
        zoomLevel() {
            return `${Math.ceil(this.zoom * 100)}%`;
        },
    },
};
</script>
<style lang="scss" scoped>
canvas {
    height: calc(85% - 1.5rem);
    object-fit: cover;
}
.main-image-container {
    height: calc(100% - 50px);
}
.gallery-1 {
    height: 100%;
    gap: 10px;
    display: flex;
    flex-direction: column;
    padding: 10px;

    .gallery-row {
        height: calc(50% - 20px);
        gap: 10px;
        flex: 1;
    }

    .image {
        display: flex;
        gap: 10px;
        height: 100%;
        width: 100%;

        img {
            max-width: 100%;
            max-height: 100%;
            width: auto;
            height: auto;
            object-fit: contain;
        }
    }
}
#viewport {
    width: 100%;
    height: 100%;
    cursor: grab;
}
</style>
